import React, { useState, useRef } from 'react';
import { useField } from 'formik';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormGroup,
    InputAdornment,
    FilledInput,
    InputLabel,
    OutlinedInput,
    Radio,
    RadioGroup,
    IconButton,
    Input
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';

const CheckboxField = ({ label, ...rest }) => {
    const [field, meta] = useField({ ...rest, type: 'checkbox' });
    return <FormControlLabel control={<Checkbox {...field} {...rest} />} label={label ? label : ''} />;
};
const RadioField = ({ label, options, ...rest }) => {
    const [field, meta] = useField({ ...rest, type: 'radio' });
    return (
        <RadioGroup row aria-labelledby="eventAttendies-label" {...field} {...rest}>
            {options.map(function (item, index) {
                return (
                    item.value && (
                        <FormControlLabel value={item.value} control={<Radio />} label={item.label ? item.label : ''} key={index} />
                    )
                );
            })}
        </RadioGroup>
    );
};
const OutlinedInputField = ({ label, ...rest }) => {
    const [field, meta] = useField({ ...rest, type: 'text' });

    return (
        <>
            {label && <InputLabel htmlFor={`outlined-adornment-${label}-register`}>{label}</InputLabel>}
            <OutlinedInput id={`outlined-adornment-${rest.name}-register`} autoComplete="off" {...field} {...rest} />
        </>
    );
};
const NormalInputField = ({ label, ...rest }) => {
    const [field, meta] = useField({ ...rest, type: 'text' });

    return (
        <>
            {label && <InputLabel htmlFor={`outlined-adornment-${label}-register`}>{label}</InputLabel>}
            <Input id={`outlined-adornment-${rest.name}-register`} autoComplete="off" {...field} {...rest} />
        </>
    );
};
const AttachmentField = ({ label, ...rest }) => {
    const [selectedFile, setSelectedFile] = useState('');
    const [field, meta] = useField({ ...rest, type: 'text' });
    const inputRef = useRef();
    return (
        <div>
            {label && <InputLabel htmlFor={`filled-adornment-${label}`}>{label}</InputLabel>}
            <FilledInput
                id="filled-adornment-attachment"
                disabled
                startAdornment={
                    <InputAdornment position="start">
                        <AttachmentOutlinedIcon />
                    </InputAdornment>
                }
                onClick={() => inputRef.current.click()}
                fullWidth
            />
            <input type="file" name="attachment" ref={inputRef} hidden />
        </div>
    );
};
const FormError = (props) => {
    const [field, meta] = useField(props);
    return (
        <>
            {meta.touched && meta.error && (
                <FormHelperText error id="standard-weight-helper-text--checkbox">
                    {meta.error}
                </FormHelperText>
            )}
        </>
    );
};
const FormFields = ({ label, type, ...rest }) => {
    return (
        <>
            {type && (
                <>
                    {type === 'checkbox' && <CheckboxField label={label} {...rest} />}
                    {type === 'outlined-input' && <OutlinedInputField label={label} {...rest} />}
                    {type === 'normal-input' && <NormalInputField label={label} {...rest} />}
                    {type === 'filled-input' && <FilledInput label={label} {...rest} />}
                    {type === 'radio' && rest.options && <RadioField label={label} {...rest} />}
                    {type === 'attachment' && <AttachmentField label={label} {...rest} />}
                    {<FormError label={label} type={type} {...rest} />}
                </>
            )}
        </>
    );
};
export default FormFields;
